import {ActionTypes} from '../actions';
import {Transfers} from '../../common/actionTypes';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingAgenciesList': false,
  'agenciesList': [],
  'loadingAgencyData': false,
  'agencyData': {},
  'loadingReplacementPartData': false,
  'replacementPartData': {},
  'savingLineInfo': false,
  'loadingPendingItemsList': false,
  'pendingItemsList': [],
  'loadingReviewedItemsList': false,
  'reviewedItemsList': [],
  'loadingPickingWarehouseDeniedList': false,
  'pickingWarehouseDeniedList': [],
  'loadingReplacementPartOrderRequestsInfo': false,
  'replacementPartOrderRequestsInfo': null,
  'savingReplacementPartWarehouseDenialCause': false,
  'creatingInvoice': false,
};

const FORM_INITIAL_STATE = {
  'values': {
    'items': [{}],
  },
};

const WAREHOUSE_DENIAL_CAUSE_FORM_INITIAL_STATE = {
  'values': {
    'denialCauseCode': '',
  },
};

function getItemsWithLineInfo(list, index, lineInfo) {
  const newObject = {
    'orderSequenceCode': lineInfo.orderSequence,
    'replacementPartCode': lineInfo.partCode,
    'replacementPartName': lineInfo.partName,
    'expectedQuantity': lineInfo.pendingQuantity,
  };
  newObject.replacementPartCodeChecked = true;

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

function getItemsWithoutLineInfo(list, index) {
  const newList = [...list];
  let newObject = {...newList[index]};
  const orderSequenceCode = newObject.orderSequenceCode;
  newObject = {};
  newObject.orderSequenceCode = orderSequenceCode;
  newObject.replacementPartCodeChecked = false;

  return [...list.slice(0, index), newObject, ...list.slice(index + 1)];
}

function getItemsWithValuesUpdated(list, index) {
  const newList = [...list];
  newList.push({});

  const newObject = {...newList[index]};
  newObject.itemSaved = true;

  return [...newList.slice(0, index), newObject, ...newList.slice(index + 1)];
}

export const scanning = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_SCANNING_INFO]: (state, action) => ({
      ...state,
      'agencyData': {},
      'replacementPartData': {},
      'savingLineInfo': false,
    }),
    [ActionTypes.FETCHING_AGENCIES_LIST]: (state, action) => ({
      ...state,
      'loadingAgenciesList': true,
    }),
    [ActionTypes.FETCHED_AGENCIES_LIST]: (state, action) => ({
      ...state,
      'loadingAgenciesList': false,
      'agenciesList': action.response.data,
    }),
    [ActionTypes.FETCHED_AGENCIES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingAgenciesList': false,
      'agenciesList': [],
    }),
    [ActionTypes.FETCHING_AGENCY]: (state, action) => ({
      ...state,
      'loadingAgencyData': true,
    }),
    [ActionTypes.FETCHED_AGENCY]: (state, action) => {
      const agency = {
        'checkedLines': action.response.data.checkedLines,
        'totalLines': action.response.data.totalLines,
        'code': action.payload.agency.code,
        'name': action.payload.agency.name,
        'dealerIdentification': action.payload.agency.dealerIdentification,
        'dealerName': action.payload.agency.dealerName,
      };

      return ({
        ...state,
        'loadingAgencyData': false,
        'agencyData': agency,
      });
    },
    [ActionTypes.FETCHED_AGENCY_FAILED]: (state, action) => ({
      ...state,
      'loadingAgencyData': false,
      'agencyData': {},
    }),
    [ActionTypes.FETCHING_REPLACEMENT_PART]: (state, action) => ({
      ...state,
      'loadingReplacementPartData': true,
    }),
    [ActionTypes.FETCHED_REPLACEMENT_PART]: (state, action) => ({
      ...state,
      'loadingReplacementPartData': false,
      'replacementPartData': action.response.data,
    }),
    [ActionTypes.FETCHED_REPLACEMENT_PART_FAILED]: (state, action) => ({
      ...state,
      'loadingReplacementPartData': false,
      'replacementPartData': {},
    }),
    [ActionTypes.SAVING_LINE_INFO]: (state, action) => ({
      ...state,
      'savingLineInfo': true,
    }),
    [ActionTypes.SAVED_LINE_INFO]: (state, action) => {
      return ({
        ...state,
        'savingLineInfo': false,
      });
    },
    [ActionTypes.SAVED_LINE_INFO_FAILED]: (state, action) => {
      return ({
        ...state,
        'savingLineInfo': false,
      });
    },
    [ActionTypes.FETCHING_PENDING_ITEMS_LIST]: (state, action) => ({
      ...state,
      'loadingPendingItemsList': true,
    }),
    [ActionTypes.FETCHED_PENDING_ITEMS_LIST]: (state, action) => ({
      ...state,
      'loadingPendingItemsList': false,
      'pendingItemsList': action.response.data,
    }),
    [ActionTypes.FETCHED_PENDING_ITEMS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingPendingItemsList': false,
      'pendingItemsList': [],
    }),
    [ActionTypes.FETCHING_REVIEWED_ITEMS_LIST]: (state, action) => ({
      ...state,
      'loadingReviewedItemsList': true,
    }),
    [ActionTypes.FETCHED_REVIEWED_ITEMS_LIST]: (state, action) => ({
      ...state,
      'loadingReviewedItemsList': false,
      'reviewedItemsList': action.response.data,
    }),
    [ActionTypes.FETCHED_REVIEWED_ITEMS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingReviewedItemsList': false,
      'reviewedItemsList': [],
    }),
    [ActionTypes.FETCHING_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST]: (state, action) => ({
      ...state,
      'loadingPickingWarehouseDeniedList': true,
    }),
    [ActionTypes.FETCHED_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST]: (state, action) => ({
      ...state,
      'loadingPickingWarehouseDeniedList': false,
      'pickingWarehouseDeniedList': action.response.data,
    }),
    [ActionTypes.FETCHED_SCANNING_WAREHOUSE_DENIAL_CAUSES_LIST_FAILED]: (state, action) => ({
      ...state,
      'loadingPickingWarehouseDeniedList': false,
      'pickingWarehouseDeniedList': [],
    }),
    [ActionTypes.FETCHING_REPLACEMENT_PART_ORDER_REQUESTS_INFO]: (state, action) => ({
      ...state,
      'loadingReplacementPartOrderRequestsInfo': true,
    }),
    [ActionTypes.FETCHED_REPLACEMENT_PART_ORDER_REQUESTS_INFO]: (state, action) => ({
      ...state,
      'loadingReplacementPartOrderRequestsInfo': false,
      'replacementPartOrderRequestsInfo': action.response.data,
    }),
    [ActionTypes.FETCHED_REPLACEMENT_PART_ORDER_REQUESTS_INFO_FAILED]: (state, action) => ({
      ...state,
      'loadingReplacementPartOrderRequestsInfo': false,
      'replacementPartOrderRequestsInfo': null,
    }),
    [ActionTypes.SAVING_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE]: (state, action) => ({
      ...state,
      'savingReplacementPartWarehouseDenialCause': true,
    }),
    [ActionTypes.SAVED_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE]: (state, action) => {
      return ({
        ...state,
        'savingReplacementPartWarehouseDenialCause': false,
      });
    },
    [ActionTypes.SAVED_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE_FAILED]: (state, action) => {
      return ({
        ...state,
        'savingReplacementPartWarehouseDenialCause': false,
      });
    },
    [ActionTypes.CREATING_SALE_INVOICE]: (state, action) => ({
      ...state,
      'creatingInvoice': true,
    }),
    [ActionTypes.CREATED_SALE_INVOICE]: (state, action) => ({
      ...state,
      'creatingInvoice': false,
      'agencyData': {},
    }),
    [ActionTypes.CREATED_SALE_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'creatingInvoice': false,
    }),
    [Transfers.PROCESSING_STOCK_TRANSFER]: (state, action) => ({
      ...state,
      'creatingInvoice': true,
    }),
    [Transfers.PROCESSED_STOCK_TRANSFER]: (state, action) => ({
      ...state,
      'creatingInvoice': false,
      'agencyData': {},
    }),
    [Transfers.PROCESSED_STOCK_TRANSFER_FAILED]: (state, action) => ({
      ...state,
      'creatingInvoice': false,
    }),
  })(state, action);
};

export const scanningForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.CLEAR_SCANNING_ITEMS]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'items': [{}],
      },
    }),
    [ActionTypes.FETCHED_REPLACEMENT_PART]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'items': getItemsWithLineInfo(state.values.items, action.payload, action.response.data),
      },
    }),
    [ActionTypes.FETCHED_REPLACEMENT_PART_FAILED]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'items': getItemsWithoutLineInfo(state.values.items, action.payload),
      },
    }),
    [ActionTypes.SAVED_LINE_INFO]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
        'items': getItemsWithValuesUpdated(state.values.items, action.payload),
      },
    }),
    [ActionTypes.INVOICE_GENERATED]: (state, action) => ({
      ...state,
    }),
  })(state, action);
};

export const scanningWarehouseDenialCauseForm = (state, action) => {
  return createReducer(WAREHOUSE_DENIAL_CAUSE_FORM_INITIAL_STATE, {
    [ActionTypes.SAVED_REPLACEMENT_PART_WAREHOUSE_DENIAL_CAUSE]: (state, action) => ({
      ...state,
      'values': {
        ...state.values,
      },
    }),
  })(state, action);
};
